import type { UpdatedDevice, MovedToAnotherDeviceMessage } from '@/types/user'
import type { LocationState } from '@/store/location'

export interface UserSettings {
  visited?: boolean | null
  lastViewedVersion?: string
  viewedSubscriptionExpired?: boolean | null
  devicesUpdated?: UpdatedDevice[]
  movedToAnotherDeviceMessages?: MovedToAnotherDeviceMessage[]
  showDataGapLine?: boolean | null
}

export interface UserState {
  settings: UserSettings
  location?: LocationState
}

export enum USER_MUTATIONS {
  SET_SETTINGS = 'setSettings',
  UPDATE_SETTINGS = 'updateSettings'
}

export enum USER_ACTIONS {
  SET_SETTINGS = 'setSettings',
  UPDATE_SETTINGS = 'updateSettings'
}

export enum USER_GETTERS {
  GET_DEVICES_UPDATED = 'getDevicesUpdated',
  GET_VIEWED_SUBSCRIPTION_EXPIRED = 'getViewedSubscriptionExpired',
  GET_LAST_VIEWED_VERSION = 'getLastViewedVersion',
  GET_VISITED = 'getVisited',
  GET_MOVED_TO_ANOTHER_DEVICE_MESSAGES = 'getMovedToAnotherDeviceMessages',
  GET_SHOW_DATA_GAP_LINE = 'getShowDataGapLine'
}
